import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductosService } from 'src/app/services/productos.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-producto',
  templateUrl: './producto.component.html',
  styleUrls: ['./producto.component.scss']
})
export class ProductoComponent implements OnInit {
  idProd: string;
  nombre: string;
  categoria: string;
  descripcion: string;
  gr1000: number;
  gr1500: number;
  litro: number;
  litroVal: number;
  ltrPist: number;
  ltrPistRep: number;
  litro5: number;
  litro20: number;
  litro38: number;
  kg1: number;
  kg4: number;
  kg21: number;
  kg22: number;
  kg44: number;
  sinAroma: string;
  floral: string;
  citronela: string;
  lavanda: string;
  vinagre: string;
  frutosRojos: string;
  kiwi: string;
  limon: string;
  imagen: string;
  precio: number;
  amarillo: string;
  azul: string;
  rojo: string;
  gris: string;
  verde: string;
  negro: string;
  blanco: string;
  prtacion: string;
  contenido: string;
  color: string;
  tL: string;
  tM: string;
  tS: string;
  cant = 1;
  compra = [];
  promocion: number;
  precioDesc: number;

  carshop: any = {
    nombre: '',
    imagen: '',
    presentacion: '',
    color: '',
    tamano: '',
    cantidad: 0,
    precio: 0,
    total: 0
  };

  constructor(private prodSvc: ProductosService,
              private route: ActivatedRoute,
              private router: Router) {
    this.loadStorage();
  }

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    if (this.prodSvc.producto) {      
      this.promocion = this.prodSvc.producto.descuento;
      this.categoria = this.prodSvc.producto.categoria;
      this.idProd = this.prodSvc.producto.id;
      this.nombre = this.prodSvc.producto.nombre;
      this.descripcion = this.prodSvc.producto.descripcion;
      this.imagen = this.prodSvc.producto.imageProd;
      this.gr1000 = this.prodSvc.producto.gr1000;
      this.gr1500 = this.prodSvc.producto.gr1500;
      this.litro = this.prodSvc.producto.lt1;
      this.litroVal = this.prodSvc.producto.ltvalvula;
      this.ltrPist = this.prodSvc.producto.ltrPist;
      this.ltrPistRep = this.prodSvc.producto.ltrPistRep;
      this.litro5 = this.prodSvc.producto.lt5;
      this.litro20 = this.prodSvc.producto.lt20;
      this.litro38 = this.prodSvc.producto.ltr38;
      this.kiwi = this.prodSvc.producto.kiwi;
      this.limon = this.prodSvc.producto.limon;
      this.sinAroma = this.prodSvc.producto.sinAroma;
      this.floral = this.prodSvc.producto.floral;
      this.citronela = this.prodSvc.producto.citronela;
      this.lavanda = this.prodSvc.producto.lavanda;
      this.vinagre = this.prodSvc.producto.vinagre;
      this.frutosRojos = this.prodSvc.producto.frutosRojos;
      this.kg1 = this.prodSvc.producto.kg1;
      this.kg4 = this.prodSvc.producto.kg4;
      this.kg44 = this.prodSvc.producto.kg44;
      this.kg21 = this.prodSvc.producto.kg21;
      this.kg22 = this.prodSvc.producto.kg22;
      this.tL = this.prodSvc.producto.tL;
      this.tM = this.prodSvc.producto.tM;
      this.tS = this.prodSvc.producto.tS;
      this.precio = this.prodSvc.producto.precio;
      this.amarillo = this.prodSvc.producto.amarillo;
      this.azul = this.prodSvc.producto.azul;
      this.rojo = this.prodSvc.producto.rojo;
      this.gris = this.prodSvc.producto.gris;
      this.verde = this.prodSvc.producto.verde;
      this.negro = this.prodSvc.producto.negro;
      this.blanco = this.prodSvc.producto.blanco;
    } else {
       this.router.navigate(['/productos']);
    }
  }

  cantidadIngresada(event: number){
    this.cant = event;
  }

  cantidadProducto(operacion: string){
    if (operacion === 'restar') {
      this.cant--;
      if (this.cant < 1) {
        this.cant = 1;
      }
    }
    if (operacion === 'sumar') {
      this.cant++;
    }
  }

  loadStorage(){
    if (localStorage.getItem('data')) {
      this.compra = JSON.parse( localStorage.getItem('data'));
    }
  }

  precioProducto(price: number, contenido: string){
    this.precio = Number(price.toFixed(0));
    this.contenido = contenido;  
    if (this.promocion > 0 && this.promocion) {
      const prc = Number(this.precio - ((this.precio * this.promocion)/100));
      this.precioDesc = Number(prc.toFixed(0));
    }  
  }

  presentacion(present: string){
    this.prtacion = present;
    // console.log(this.prtacion);
  }

  colorSeleccionado(clr: string){
    this.color = clr;
    // console.log(this.color);
    Swal.fire(
      'Ha seleccionado el color: ' + '' + this.color,
      '',
      'success'
    );
  }

  addCarShop(){
    console.log(this.prtacion);
    
   if (this.promocion > 0 && this.promocion) {
     this.precio = this.precioDesc;
   }
  if (this.precio > 0) {
    if (this.kiwi === 'Si'||this.limon === 'Si'||this.sinAroma === 'Si'||this.floral === 'Si'||this.citronela === 'Si'||this.lavanda === 'Si'||this.vinagre === 'Si'||this.frutosRojos === 'Si') {
      if (!this.prtacion) {
        Swal.fire('Por favor seleccione el aroma o presentación para continuar');
        return;
      }
    }
    const total = this.precio * this.cant;
    this.carshop.nombre = this.nombre;
    this.carshop.imagen = this.imagen;
    this.carshop.presentacion = this.prtacion;
    this.carshop.tamano = this.contenido;
    this.carshop.color = this.color;
    this.carshop.cantidad = this.cant;
    this.carshop.precio = this.precio;
    this.carshop.total = total;
    this.compra.push(this.carshop);
    localStorage.setItem('data', JSON.stringify(this.compra));
    Swal.fire({
      title: 'Se han agregado' + ' ' + this.cant + ' unidades de' + ' ' + this.nombre + ' al carrito de compras',
      showClass: {
        popup: 'animate__animated animate__fadeInDown'
      },
      hideClass: {
        popup: 'animate__animated animate__fadeOutUp'
      }
    });
    // console.log(this.carshop);
    this.router.navigate(['compras']);
  } else {
    Swal.fire(
      'Faltan datos para la compra.',
      'Debe elegir el tipo de producto y presentación.',
      'error'
    );
    return;
  }
  }
}
